import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'

import styles from './IconText.module.scss'

/** @type {import("./types").default} */
const IconText = ({ className, icon, text, variant = 'large', ...props }) => {
  const isLarge = variant === 'large'
  const Component = 'div'

  return (
    <Component className={clsx('IconText', styles.root, className)} {...props}>
      <Icon className={styles.icon} icon={icon} size={12} />
      <Typography variant={isLarge ? 'body-sm' : 'body-xs'}>{text}</Typography>
    </Component>
  )
}

export default IconText
